import { gsap } from 'gsap';
function Animate(
  sprite,
  { duration = 1, speed = 1, ease = 'power3.out', type, elementToAnimate, delayValue, direction }
) {
  let animation;
  duration = duration * speed;
  let steps = elementToAnimate?.length || 1;
  if (type == 'entry') {
    animation = gsap.from(elementToAnimate, {
      duration: duration,
      pixi: {
        alpha: 0,
        x: (index, target) => calculateXCoord(index, target, direction),
        y: (index, target) => calculateYCoord(index, target, direction),
      },
      repeat: 0,
      delay: delayValue,
      ease: ease,
      stagger: duration / steps,
    });
  } else {
    animation = gsap.to(elementToAnimate, {
      duration: duration,
      pixi: {
        alpha: 0,
        x: (index, target) => calculateXCoord(index, target, direction),
        y: (index, target) => calculateYCoord(index, target, direction),
      },
      repeat: 0,
      delay: steps > 1 ? delayValue - duration : delayValue,
      ease: 'power3.in',
      stagger: duration / steps,
    });
  }
  return animation;
}

function calculateXCoord(index, target, direction) {
  var animX;
  let width = target.width;
  if (target?.style?.fontSize) {
    width = parseFloat(0.5 * target.style.fontSize.replace('px', ''));
  }
  switch (direction) {
    case 'up':
    case 'down':
      animX = 0;
      break;
    case 'left':
      animX = width;
      break;
    case 'right':
      animX = -width;
      break;
  }
  return target.x + animX;
}

function calculateYCoord(index, target, direction) {
  var animY;
  switch (direction) {
    case 'up':
      animY = target.height;
      break;
    case 'down':
      animY = -target.height;
      break;
    case 'left':
    case 'right':
      animY = 0;
      break;
  }
  return target.y + animY;
}

export default { Animate };
